import { FormControl, TextField, withStyles } from "@material-ui/core";
import { checkEmployeeToken } from "../../service/authentication"; // Add this line
import apiErrorResponse from "../../errorDefinition/ApiErrorResponse";
import WarningIcon from "@material-ui/icons/Warning";
import moment from "moment";
import React from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import Moeda from "../../utils/Moeda";
import CardExpenses from "../CardComponents/CardsExpenses/Card";
import ExpansionPanel from "../ExpansionPanel/ExpansionPanel";
import SelectInput from "../Inputs/SelectInput";
import AmountMask from "../MaskedInputs/AmountMask";
import ConnectionErrorNotFound from "../../errorDefinition/ConnectionErrorNotFound"
import ConnectionErrorFetchFaild from "../../errorDefinition/ConnectionErrorFetchFaild";
import ConnectionErrorTimeOut from "../../errorDefinition/ConnectionErrorTimeOut";
import ConnectionErrorServerSide from "../../errorDefinition/ConnectionErrorServerSide";
import { getUser } from "../../service/authentication";

const styles = (theme) => ({
  expansionPanel: {},

  "fade-enter": {
    maxHeight: 0,
    opacity: 0,
  },
  "fade-enter-active": {
    opacity: 1,
    maxHeight: "100vh",
    transition: "all 500ms",
  },
  "fade-exit": {
    opacity: 1,
    maxHeight: "100vh",
  },
  "fade-exit-active": {
    opacity: 0,
    maxHeight: 0,
    transition: "all 500ms",
  },
});

class VoucherComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expensesArray: [],
      invalid: false,
      requiredFieldsArray: ["valor", "funcionarioId"],
      selectedEmployeesArray: [],
      invalidValueHelperText: "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.onHandleChange = this.onHandleChange.bind(this);
    this.onAddExpense = this.onAddExpense.bind(this);
    this.onDeleteExpense = this.onDeleteExpense.bind(this);
    this.onSaveExpense = this.onSaveExpense.bind(this);
    this.validateFields = this.validateFields.bind(this);
    this.verificaEmergencia = this.verificaEmergencia.bind(this);
    this.verificaLimiteMensal = this.verificaLimiteMensal.bind(this);
    this.verificaLimiteDiario = this.verificaLimiteDiario.bind(this);
    this.verificaLimiteDiaSemana = this.verificaLimiteDiaSemana.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.expenseContext.isLoading !== this.props.expenseContext.isLoading
    ) {
      let empArray = [];
      let savedExpenses = this.props.expenseContext[this.props.modelName].value;
      let newSavedExpenses = savedExpenses.map((expense) => {
        let exp = {};
        for (let key in expense) {
          exp[key] = { value: expense[key], error: false };
        }
        // Update selectedEmployeesArray
        let employee = this.props.expenseContext.employees.value.find(
          (e) => e.id == expense.funcionarioId
        );
        if (employee) empArray.push(employee);
        exp.isSaved = true;
        return exp;
      });
      if (!newSavedExpenses.length) {
        let invalid = false;
        this.setState({ invalid });
      }
      this.setState({
        expensesArray: newSavedExpenses,
        selectedEmployeesArray: empArray,
      });
    }
  }

  getMaxMoneyAdvance(funcionario, QUANTIDADE_RECEBIMENTO_MES) {
    if (funcionario.regime.regime.toLocaleUpperCase() !== "LIVRE") {
      if (funcionario.regime.regime.toLocaleUpperCase() === "FIXO") {
        return Moeda.create(funcionario.regime.teto).mount();
      } else if (funcionario.regime.regime.toLocaleUpperCase() === "IDEAL") {
        // const percentTeto = Percent.create(funcionario.regime.teto + "%").toNumber();
        return Moeda.create(QUANTIDADE_RECEBIMENTO_MES)
          .mul(funcionario.regime.teto)
          .mount();
      }
    }
  }

  verificaLimiteMensal(valorMax, valorRequisitado, emergencia, limiteMensal, funcionario, totalEmergencialDoDia, indiceVetorAdiantamentos) {
    const saldoDisponivel = Moeda.create(valorMax).subtract(valorRequisitado);
    const possoPegarPeloLimite =
      !Moeda.create(saldoDisponivel).isLessThan("0,00");

    const possoPegarPeloLimiteMensal =
      Moeda.create(valorRequisitado).isLessOrEqualThan(limiteMensal);

    if (possoPegarPeloLimite && possoPegarPeloLimiteMensal) {
      return { error: 0, msg: "" };
    }

    valorRequisitado = valorRequisitado.add(totalEmergencialDoDia);

    const valorMaiorQueEmergencia =
      Moeda.create(valorRequisitado).isGreaterThan(emergencia);

    if (valorMaiorQueEmergencia) {
      return {
        error: 1,
        msg: `${Moeda.create(
          valorRequisitado
        ).format()} não pode ser pego. Limite de ${Moeda.create(
          valorMax
        ).format()}. Emergência: ${Moeda.create(emergencia).format()}`,
      };
    }

   /* if (!this.verificaEmergencia(funcionario, emergencia)) {
      return {
        error: 1,
        msg: `${Moeda.create(
          valorRequisitado
        ).format()} não pode ser pego. Limite de ${Moeda.create(
          valorMax
        ).format()}. Emergência já foi pego`,
      };
    }*/

      // Seta como emergencial
      let expense = [...this.state.expensesArray];
      expense[indiceVetorAdiantamentos].emergencial = true
      this.setState({
        expensesArray: expense,
      });
      // fim de setar

    return { error: 0, msg: "" };
  }

  verificaLimiteDiario(valorMax, valorRequisitado, emergencia, limiteDiario, totalRequisitadoParaODia, totalEmergencialDoDia, indiceVetorAdiantamentos) {
    const saldoDisponivel = Moeda.create(valorMax).subtract(valorRequisitado);
    const possoPegarPeloLimite =
      !Moeda.create(saldoDisponivel).isLessThan("0,00");

    const valorTotalRequisitadoMaisOJaPego = valorRequisitado.add(totalRequisitadoParaODia);

    const possoPegarPeloLimiteDiario =
      Moeda.create(valorTotalRequisitadoMaisOJaPego).isLessOrEqualThan(limiteDiario);

    if (possoPegarPeloLimite && possoPegarPeloLimiteDiario) {
      return { error: 0, msg: "" };
    }

    valorRequisitado = valorRequisitado.add(totalEmergencialDoDia);

    const valorMaiorQueEmergencia =
      Moeda.create(valorRequisitado).isGreaterThan(emergencia);

    if (valorMaiorQueEmergencia) {
      return {
        error: 1,
        msg: `${Moeda.create(
          valorRequisitado
        ).format()} não pode ser pego. Limite de ${Moeda.create(
          valorMax
        ).format()}. Emergência: ${Moeda.create(emergencia).format()}`,
      };
    }

    if (Moeda.create(valorMax).isLessThan("0,00")) {
      return {
        error: 1,
        msg: `${Moeda.create(
          valorRequisitado
        ).format()} não pode ser pego. Limite de ${Moeda.create(
          valorMax
        ).format()}. Emergência já foi pego`,
      };
    }


    // Seta como emergencial
    let expense = [...this.state.expensesArray];
    expense[indiceVetorAdiantamentos].emergencial = true
    this.setState({
      expensesArray: expense,
    });
    // fim de setar


    return { error: 0, msg: "" };
  }

  verificaLimiteDiaSemana(
    valorMax,
    valorRequisitado,
    emergencia,
    limiteDiaSemana
  ) {
    const saldoDisponivel = Moeda.create(valorMax).subtract(valorRequisitado);
    const possoPegarPeloLimite =
      !Moeda.create(saldoDisponivel).isLessThan("0,00");

    const possoPegarPeloLimiteDiario =
      !Moeda.create(valorRequisitado).isLessOrEqualThan(limiteDiaSemana);
    if (possoPegarPeloLimite && possoPegarPeloLimiteDiario) {
      return { error: 0, msg: "" };
    }

    const valorMaiorQueEmergencia =
      Moeda.create(valorRequisitado).isGreaterThan(emergencia);

    if (valorMaiorQueEmergencia) {
      return {
        error: 1,
        msg: `${Moeda.create(
          valorRequisitado
        ).format()} não pode ser pego. Limite de ${Moeda.create(
          valorMax
        ).format()}. Emergência: ${Moeda.create(emergencia).format()}`,
      };
    }

    if (Moeda.create(valorMax).isLessThan("0,00")) {
      return {
        error: 1,
        msg: `${Moeda.create(
          valorRequisitado
        ).format()} não pode ser pego. Limite de ${Moeda.create(
          valorMax
        ).format()}. Emergência já foi pego`,
      };
    }

    return { error: 0, msg: "" };
  }

  // Função para verificar se o limite de emergência já foi atingido hoje
  verificaEmergencia(funcionario, emergencia) {
    const hoje = moment().format("YYYY-MM-DD");
    const adiantamentos = this.props.expenseContext.voucherExpenses.value;
    const totalAdiantamentosHoje = adiantamentos.reduce(
      (acc, adiantamento) =>
        adiantamento.funcionarioId === funcionario.id &&
          moment(adiantamento.data).format("YYYY-MM-DD") === hoje
          ? acc.add(Moeda.create(adiantamento.valor))
          : acc,
      Moeda.create(0)
    );

    const adiantamentosHoje = Moeda.create(totalAdiantamentosHoje).isLessThan(emergencia)
    return adiantamentosHoje;
  }

  validateRequisicaoAdiantamento(funcionario, valorMax, valorRequisitado, totalRequisitadoParaODia, totalEmergencialDoDia, indiceVetorAdiantamentos) {
    const regime = funcionario.regime;

    if (regime.regime.toLocaleUpperCase() === "LIVRE") {
      return { error: 0, msg: "" };
    }

    const emergencia = Moeda.create(regime.emergencia);
    valorRequisitado = Moeda.create(valorRequisitado);
    valorMax = Moeda.create(valorMax);

    // Encontra o limitante pela forma de distribuição
    if (regime.divisao.toLocaleUpperCase() === "MENSAL") {
      return this.verificaLimiteMensal(
        valorMax,
        valorRequisitado,
        emergencia,
        regime.teto,
        funcionario,
        totalEmergencialDoDia,
        indiceVetorAdiantamentos
      );
    } else if (regime.divisao.toLocaleUpperCase() === "DIARIO") {
      return this.verificaLimiteDiario(
        valorMax,
        valorRequisitado,
        emergencia,
        regime.limiteDiario,
        totalRequisitadoParaODia,
        totalEmergencialDoDia,
        indiceVetorAdiantamentos
      );
    } else if (regime.divisao.toLocaleUpperCase() === "DSEMANA") {
      const weekDay = moment().format("ddd").toLowerCase();
      const limiteDiaSemana = regime.distribuicao[weekDay];
      return this.verificaLimiteDiaSemana(
        valorMax,
        valorRequisitado,
        emergencia,
        limiteDiaSemana
      );
    }
    return {
      error: 1,
      msg: `O valor ${Moeda.create(
        valorRequisitado
      ).format()} não pode ser pego.`,
    };
  }

  async handleInputChange(event, input, index) {
    let tempExpenseArray = [...this.state.expensesArray];
    if (input === "valor") {
      tempExpenseArray[index][input].value = event;
    } else if (input == "funcionarioId") {
      const findEmployee = (e) => e.id == event;

      tempExpenseArray[index][input].value = event;
      const isHaveEmployee =
        this.state.selectedEmployeesArray.find(findEmployee);
      if (!isHaveEmployee) {
        const empArray = [...this.state.selectedEmployeesArray];
        const employee =
          this.props.expenseContext.employees.value.find(findEmployee);
        empArray.push(employee);
        this.setState({ selectedEmployeesArray: empArray });
      }
    } else tempExpenseArray[index][input].value = event.target.value;

    tempExpenseArray[index].isSaved = false;
    this.setState({ expensesArray: tempExpenseArray });
  }

  onHandleChange(isExpanded) {
    this.props.handleChange(isExpanded);
  }  

  async httpPost(url, options)
  {
    try
    {
      const response = await fetch(url, options);
      if (!response.ok)
      {
        if (response.status >= 400 && response.status < 500)
        {
          throw new ConnectionErrorNotFound({ url });
        } else if (response.status == 504)
        {
          throw new ConnectionErrorTimeOut({ url });
        } else
        {
          throw new ConnectionErrorServerSide({ url });
        }
      }
      return response;
    } catch (error)
    {
      if (error.message == "Failed to fetch")
        throw new ConnectionErrorFetchFaild({ url });
    }
  }


  async onAddExpense() {
    if (await this.props.onAddExpense()) {
      let newExpenseObj = {
        funcionarioId: { value: "", error: false },
        descricao: { value: "", error: false },
        valor: { value: "", error: false },
        isSaved: false,
        emergencial: false,
      };
      this.setState({
        expensesArray: [...this.state.expensesArray, newExpenseObj],
      });
      this.setState({ invalid: true });
    }
  }

  async onDeleteExpense(index) {
    const initialLength = this.state.expensesArray.length;
    let expense = this.state.expensesArray.map((expense) => {
      let exp = {};
      for (let key in expense) {
        if ( key === "isSaved")
          exp[key] = expense[key]
        else
          exp[key] = expense[key].value;
      }
      return exp;
    });
    if (expense[index].DATABASE_ID) {
      await this.props.onDeleteExpense(this.props.modelName, expense[index]);

      if (initialLength === 1) {
        let temp_expensesArray = [...this.state.expensesArray];
        temp_expensesArray.splice(index, 1);
        this.setState({ expensesArray: temp_expensesArray });
      }
      this.setState({ invalid: false });
    }
  }

  async onSaveExpense(index) {
    const resultadoOpercao = await this.validateFields(index);
    if (resultadoOpercao) {
      let exp = {};
      for (let key in this.state.expensesArray[index]) {
        if (typeof (this.state.expensesArray[index][key]) == "boolean") {
          exp[key] = this.state.expensesArray[index][key];
        }
        else {
          exp[key] = this.state.expensesArray[index][key].value;
        }
      }
      if (this.state.expensesArray[index].DATABASE_ID) {
        exp.DATABASE_ID = this.state.expensesArray[index].DATABASE_ID.value;
      }
      let success = await this.props.onSaveExpense(this.props.modelName, exp);
      if (success) {
        // Change isSaved property
        let temp_expensesArray = [...this.state.expensesArray];
        temp_expensesArray[index].isSaved = true;
        this.setState({ invalid: false, expensesArray: temp_expensesArray });
      }
    } else return;
  }

  async resolveFetchResponse(response)
  {
    const data = await response.json();
    if (data.error)
    {
      await checkEmployeeToken(data, response.abort);
      throw new apiErrorResponse({
        message: data.message || data.msg,
        title: "Oops, houve um problema",
        type: "error",
        error: new Error(),
      });
    }
    return data;
  }


  async validateFields(index) {
    let requiredFieldsArray = this.state.requiredFieldsArray;
    let formInvalid = false;

    for (let i = 0; i < requiredFieldsArray.length; i++) {
      if (
        this.state.expensesArray[index][requiredFieldsArray[i]].value === ""
      ) {
        let expense = [...this.state.expensesArray];
        expense[index][requiredFieldsArray[i]].error = true;
        formInvalid = true;
        this.setState({ expensesArray: expense });
      } else {
        let expense = [...this.state.expensesArray];
        expense[index][requiredFieldsArray[i]].error = false;
        this.setState({ expensesArray: expense });
      }
      const employee = this.state.selectedEmployeesArray.find(
        (el) => el.id == this.state.expensesArray[index].funcionarioId.value
      );

      if (employee) {
        const adiantamentos =
          this.props.expenseContext.voucherExpenses.value.filter(
            (voucher) => voucher.FuncionarioId == employee.id
          );
        // Parte referente ao limite diário
        const dataDeHoje = new Date(new Date().toDateString());
        const adiantamentosDiarios = adiantamentos.filter(
          (voucher) => {
            const dataDaRequisicao = new Date(new Date(voucher.data).toDateString());
            return (dataDaRequisicao.toISOString() === dataDeHoje.toISOString())
          }
        );

        const adiamentosNaoEmergencial = adiantamentosDiarios.filter(
          (voucher) => !this.verificaSeEhEmergencial(voucher)
        );
        const adiantamentosEmergenciais = adiantamentosDiarios.filter(
          (voucher) => this.verificaSeEhEmergencial(voucher)
        );
        const totalRequisitadoParaODia = adiamentosNaoEmergencial.reduce(
          (memo, r) => memo.add(r.valor || "0,00"),
          Moeda.create("0,00")
        );
        // Parte referente ao valor dos vales emergenciais
        const totalEmergencialDoDia = adiantamentosEmergenciais.reduce(
          (memo, r) => memo.add(r.valor || "0,00"),
          Moeda.create("0,00")
        );


        // Fim da parte refetente aos valor dos vales emergenciais
        // Fim da parte do limite diário

        // Total pego no mês
        const adiantamentosMensal = adiantamentos.filter(
          (voucher) => {
            const dataDaRequisicao = new Date(new Date(voucher.data).toDateString());
            return ((dataDaRequisicao.getMonth() === dataDeHoje.getMonth()) && !this.verificaSeEhEmergencial(voucher))
          }
        );
        // Fim do Total pego no mês

        const valorVale = Moeda.create(
          this.state.expensesArray[index].valor.value || "0,00"
        ).mount();
        /*const valesTotalAdiantamentosCriados = adiantamentos.reduce(
          (memo, a) => memo.add(a.valor || "0,00"),
          Moeda.create(employee.valeMes || "0,00")
        );*/

        const valesTotalAdiantamentosCriados = adiantamentosMensal.reduce(
          (memo, a) => memo.add(a.valor || "0,00"),
          Moeda.create("0,00")
        );
        const recebimentoCelular =
          this.props.expenseContext.clientReceivement.value;
        const totalRecebimentos = recebimentoCelular.reduce(
          (memo, r) => memo.add(r.valor || "0,00"),
          Moeda.create(employee.totalRecebimentos)
        );
        //VERIFICAR A POSSIBILIDADE DE ACEITAR O VALE
        const valorMax = this.getMaxMoneyAdvance(
          employee,
          totalRecebimentos.ammount
        );
        const valorMaxCorrection = Moeda.create(valorMax || "0,00")
          .subtract(valesTotalAdiantamentosCriados || "0,00")
          .mount(); // Volte aqui para achar o limite

        const isValid = this.validateRequisicaoAdiantamento(
          employee,
          valorMaxCorrection,
          valorVale,
          totalRequisitadoParaODia,
          totalEmergencialDoDia,
          index
        );

        // Nova Parte
        const isValid2 = await this.requesitaAutorizacaoEmServidor(valorVale, employee, adiantamentos, index, valorMaxCorrection, Moeda.create(employee.regime.emergencia).mount() );
        // Fim da Nova Parte

        

        if (isValid2.error) {
          let expense = [...this.state.expensesArray];
          expense[index].valor.error = true;
          formInvalid = true;
          this.setState({
            expensesArray: expense,
            invalidValueHelperText: isValid.msg,
          });
        }
      }
    }

    if (!formInvalid) {
      return true;
    } else return false;
  }

  async requesitaAutorizacaoEmServidor(valorVale, employee, adiantamentos, indiceVetorAdiantamentos, valorMaximo, valorEmergencia)
  {
    let user = await getUser();
    const URL = `${user.service}/api/adiantamentos/autoriza_retirada?token=${user.sessao.token}`;
    const response = await this.httpPost(URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        valorSolicitado: valorVale,
        idDoFuncionario: employee.id,
        adiantamentosJaPegos: adiantamentos
      }),
    });

    const resposta = await this.resolveFetchResponse(response);
    const data = resposta.dados;
    if (data.podePegarValor)
    {
      if (data.ehEmergencial)
      {
        let expense = [...this.state.expensesArray];
        expense[indiceVetorAdiantamentos].emergencial = true
        this.setState({
          expensesArray: expense,
        });
      }
      return { error: 0, msg: "" };
    }
    else
    {
      return {
        error: 1,
        msg: `${Moeda.create(
          valorVale
        ).format()} não pode ser pego. Limite de ${Moeda.create(
          valorMaximo
        ).format()}. Emergência: ${Moeda.create(valorEmergencia).format()}`,
      };
    }
  }

  verificaSeEhEmergencial(voucher) {
    return voucher.emergencial != null && voucher.emergencial != false;
  }

  render() {
    let { classes } = this.props;

    return (
      <ExpansionPanel
        handleChange={this.onHandleChange}
        expanded={this.props.expanded}
        title={this.props.title || "Vale"}
        iconTitle={<WarningIcon />}
        className={classes.expansionPanel}
        expensesCount={this.state.expensesArray.length}
        isValid={!this.state.invalid}
        disableAddBtn={this.state.invalid}
        onAddExpense={this.onAddExpense}
        custom
      >
        <TransitionGroup className={classes.prodcutsList} component={null}>
          {this.state.expensesArray &&
            this.state.expensesArray.map((card, index) => (
              <CSSTransition
                timeout={500}
                classNames={{
                  enter: classes["fade-enter"],
                  enterActive: classes["fade-enter-active"],
                  exit: classes["fade-exit"],
                  exitActive: classes["fade-exit-active"],
                }}
                key={index}
              >
                <CardExpenses
                  key={index}
                  onDeleteExpense={() => this.onDeleteExpense(index)}
                  onSaveExpense={() => this.onSaveExpense(index)}
                  isSaved={card.isSaved}
                  disableDeleteBtn={card.salvoEmBanco}
                >
                  <FormControl fullWidth style={{ paddingBottom: 15 }}>
                    <SelectInput
                      label="Funcionário"
                      required
                      error={card.funcionarioId.error}
                      value={card.funcionarioId.value}
                      onChange={(event) =>
                        this.handleInputChange(event, "funcionarioId", index)
                      }
                      menuItem={(this.props.acceptsAdvanceOutStaff
                        ? this.props.expenseContext.employees.value
                        : this.props.expenseContext.employees.value.filter(
                          (emp) =>
                            emp.EquipeId ==
                            (this.props.expenseContext &&
                              this.props.expenseContext.currentUser &&
                              this.props.expenseContext.currentUser.EquipeId)
                        )
                      ).sort((a, b) =>
                        a.nome
                          .toLocaleLowerCase()
                          .localeCompare(b.nome.toLocaleLowerCase())
                      )}
                    />
                  </FormControl>

                  <FormControl fullWidth style={{ paddingBottom: 15 }}>
                    <TextField
                      label="Descrição"
                      fullWidth
                      value={card.descricao.value}
                      onChange={(event) =>
                        this.handleInputChange(event, "descricao", index)
                      }
                      error={card.descricao.error}
                      helperText={
                        card.descricao.error ? "Informe a descrição!" : null
                      }
                    ></TextField>
                  </FormControl>

                  <FormControl fullWidth style={{ paddingBottom: 15 }}>
                    <TextField
                      // label={`Valor ${card.funcionarioId.value == '' ? '' : `(máx: ${this.props.expenseContext.employees.value.find(emp => emp.id == card.funcionarioId.value) && this.props.expenseContext.employees.value.find(emp => emp.id == card.funcionarioId.value).regime.teto})`}`}
                      label={`Valor ${card.valor.error
                        ? `${this.state.invalidValueHelperText}`
                        : ""
                        }`}
                      required
                      fullWidth
                      value={card.valor.value}
                      onChange={(e1, e2) =>
                        this.handleInputChange(e2, "valor", index)
                      }
                      InputProps={{
                        inputComponent: AmountMask,
                      }}
                      error={card.valor.error}
                      helperText={card.valor.error ? "Informe o valor!" : null}
                    ></TextField>
                  </FormControl>
                </CardExpenses>
              </CSSTransition>
            ))}
        </TransitionGroup>
      </ExpansionPanel>
    );
  }
}

export default withStyles(styles)(VoucherComponent);
